import { Injectable } from '@angular/core';
import axios from 'axios';
import { IterableService } from './iterable.service';

@Injectable({
  providedIn: 'any',
})
export class ServerIterableService extends IterableService {
  async addToMailList(): Promise<unknown> {
    return axios.post('');
  }
}
